jQuery(document).ready(function($) {
    // Corrige une URL : remplace le hostname si c'est l'IP au lieu du domaine,
    // et force le format d'image à 400x500 (correction YITH)
    function fixImageUrl(url) {
        if (!url) return url;
        try {
            var parsed = new URL(url);
            if (parsed.hostname !== window.location.hostname) {
                parsed.hostname = window.location.hostname;
                url = parsed.href;
            }
        } catch(e) {}
        return url.replace(/-\d+x\d+/, '-400x500');
    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type !== 'attributes') return;
            var $img = $(mutation.target);

            if (mutation.attributeName === 'src') {
                var src = $img.attr('src');
                var fixed = fixImageUrl(src);
                if (fixed !== src) $img.attr('src', fixed);

            } else if (mutation.attributeName === 'srcset') {
                var srcset = $img.attr('srcset');
                if (srcset) {
                    var fixedSrcset = srcset.split(',').map(function(part) {
                        var trimmed = part.trim();
                        var spaceIdx = trimmed.lastIndexOf(' ');
                        var url = spaceIdx > 0 ? trimmed.substring(0, spaceIdx) : trimmed;
                        var descriptor = spaceIdx > 0 ? trimmed.substring(spaceIdx) : '';
                        return fixImageUrl(url) + descriptor;
                    }).join(', ');
                    if (fixedSrcset !== srcset) $img.attr('srcset', fixedSrcset);
                }
            }
        });
    });

    function attachLoopImageObservers(context) {
        var $context = context ? $(context) : $(document);
        $context.filter('.yith-wccl-wrapper img:first-child, .myf-product__thumbnail img:first-child')
            .add($context.find('.yith-wccl-wrapper img:first-child, .myf-product__thumbnail img:first-child'))
            .each(function() {
                var $img = $(this);
                if (!$img.data('myfLoopObserved')) {
                    $img.data('myfLoopObserved', true);
                    observer.observe(this, {
                        attributes: true,
                        attributeFilter: ['src', 'srcset']
                    });
                }
            });
    }

    attachLoopImageObservers(document);

    var lastObservedLoopAddToCart = {
        at: 0,
        itemId: '',
        itemVariant: ''
    };

    function markObservedLoopAddToCart(payload) {
        if (!payload || typeof payload !== 'object' || typeof payload.event !== 'string') {
            return;
        }

        if (payload.event.toLowerCase().indexOf('add_to_cart') === -1) {
            return;
        }

        var items = payload.ecommerce && payload.ecommerce.items;
        var firstItem = items && items.length ? items[0] : null;

        lastObservedLoopAddToCart = {
            at: Date.now(),
            itemId: firstItem && firstItem.item_id ? String(firstItem.item_id) : '',
            itemVariant: firstItem && firstItem.item_variant ? String(firstItem.item_variant) : ''
        };
    }

    function installLoopDataLayerObserver() {
        if (window.__myfLoopDataLayerObserverInstalled) {
            return;
        }

        if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
            return;
        }

        var originalPush = window.dataLayer.push.bind(window.dataLayer);
        window.dataLayer.push = function() {
            markObservedLoopAddToCart(arguments[0]);
            return originalPush.apply(window.dataLayer, arguments);
        };

        window.__myfLoopDataLayerObserverInstalled = true;
    }

    function buildLoopVariableItem($context, $button) {
        var item = {};
        var $variationForm = $context.find('.variations_form.cart.in_loop').first();

        $context.find('[name^="gtm_"]').each(function() {
            var fieldName = this.name || '';
            if (fieldName.indexOf('gtm_') !== 0) {
                return;
            }

            item[fieldName.replace('gtm_', '')] = $(this).val();
        });

        if (!item.item_id && $button && $button.length) {
            $.each($button.data() || {}, function(key, value) {
                if (key.indexOf('gtm_') !== 0) {
                    return;
                }

                item[key.replace('gtm_', '')] = value;
            });
        }

        if (!item.item_id) {
            return null;
        }

        var $quantity = $context.find('[name="quantity"]').first();
        item.quantity = $quantity.length && $quantity.val() ? $quantity.val() : 1;

        var variants = [];
        $variationForm.find('[name^="attribute_"]').each(function() {
            var $select = $(this);
            var value = $select.val();
            if (!value) {
                return;
            }

            var selectedText = $.trim($select.find('option:selected').text());
            variants.push(selectedText || value);
        });

        if (!variants.length) {
            $variationForm.find('.select_option.selected').each(function() {
                var label = $(this).attr('data-label') || $(this).data('label') || $.trim($(this).text());
                if (label) {
                    variants.push($.trim(label));
                }
            });
        }

        if (variants.length) {
            item.item_variant = variants.join(',');
        }

        return item;
    }

    function hasMatchingRecentLoopAddToCart(item, maxAgeMs) {
        if (!item || !item.item_id || !lastObservedLoopAddToCart.at) {
            return false;
        }

        if ((Date.now() - lastObservedLoopAddToCart.at) > maxAgeMs) {
            return false;
        }

        if (String(item.item_id) !== lastObservedLoopAddToCart.itemId) {
            return false;
        }

        if (item.item_variant && lastObservedLoopAddToCart.itemVariant && item.item_variant !== lastObservedLoopAddToCart.itemVariant) {
            return false;
        }

        return true;
    }

    function scheduleLoopVariableTrackingFallback($context, $button) {
        if ($('body').hasClass('single-product')) {
            return;
        }

        if (!window.pluginGtmServerSide || typeof window.pluginGtmServerSide.pushAddToCart !== 'function') {
            return;
        }

        installLoopDataLayerObserver();

        var item = buildLoopVariableItem($context, $button);
        if (!item) {
            return;
        }

        var fallbackDelay = (window.varGtmServerSide && window.varGtmServerSide.is_custom_event_name === 'yes') ? 1700 : 50;

        setTimeout(function() {
            if (hasMatchingRecentLoopAddToCart(item, 1200)) {
                return;
            }

            window.pluginGtmServerSide.pushAddToCart(item);
            markObservedLoopAddToCart({
                event: 'add_to_cart',
                ecommerce: {
                    items: [item]
                }
            });
        }, fallbackDelay);
    }

    $(document).on('click', 'li.myf-product a.add_to_cart_button:not(.disabled)', function() {
        var $button = $(this);
        var $product = $button.closest('li.myf-product');
        var $variationForm = $product.find('.variations_form.cart.in_loop').first();
        if (!$variationForm.length) {
            return;
        }

        var variationId = $variationForm.attr('data-active_variation') || $variationForm.data('active_variation');
        if (!variationId || variationId === '0') {
            return;
        }

        scheduleLoopVariableTrackingFallback($product, $button);
    });

    // Ajouter le nom de la variation depuis data-label
    function addDataLabels() {
        // Sur les pages produits, ne cibler que les produits dans les sliders (related/upsell)
        // Pour éviter les conflits avec product.js qui gère le produit principal
        var selector = 'li.myf-product .select_option_image.select_option';
        if ($('body').hasClass('single-product')) {
            selector = '.product__upsell .myf-product .select_option_image.select_option';
        }
        
        $(selector).each(function() {

            var $this = $(this);
            var dataLabel = $this.data('label');
            if (dataLabel) {
                var $yithValue = $this.find('.yith_wccl_value_wrapper');
                if ($yithValue.length && !$yithValue.find('.attribute-label').length) {
                    $yithValue.append('<span class="attribute-label">' + dataLabel + '</span>');
                }
                
                // Sélectionner automatiquement la bonne variation selon la page
                // seulement si aucune option n'est déjà sélectionnée dans ce produit
                var $product = $this.closest('li.myf-product');
                var hasSelection = $product.find('.select_option.selected').length > 0;
                var isInfusetteCategory = $('body').hasClass('term-sachets-individuels');
                
                // Sur la page "sachets individuels" : forcer "Infusette"
                // Sur les autres pages : forcer "sachet 100g"
                var shouldAutoSelect = !hasSelection && (
                    (isInfusetteCategory && dataLabel.toLowerCase() === 'infusette') ||
                    (!isInfusetteCategory && dataLabel.toLowerCase() === 'sachet 100g')
                );
                
                if (shouldAutoSelect) {
                    var $element = $this;
                    
                    // Sur l'accueil : délai fixe pour laisser WP Rocket charger YITH
                    setTimeout(function() {
                        $element.trigger('click');
                    }, 500);
                }
            }
        });
    }

    // Exécuter au chargement
    addDataLabels();

    // Observer uniquement les éléments ajoutés (childList), pas les modifications d'attributs
    var labelObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                $(mutation.addedNodes).each(function() {
                    attachLoopImageObservers(this);
                });
                addDataLabels();
            }
        });
    });

    // Observer le body pour détecter l'ajout de nouveaux éléments
    labelObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    
});